import React, { FC } from 'react';
import { Chip, ChipProps } from '@mui/material';

export type ChipConfigProps = {
  label?: string;
  color?: ChipProps['color'];
  className?: string;
};

export type StatusChipConfig = Record<string, ChipConfigProps>;

interface StatusChipProps {
  className?: string;
  config?: StatusChipConfig;
  value?: string;
}

const StatusChip: FC<StatusChipProps> = ({ config, value }) => {
  if (!value) return null;
  const currentConfig = config?.[value];

  const chipLabel = currentConfig?.label || value;
  const chipColor = currentConfig?.color || 'default';

  return (
    <Chip size="small" label={chipLabel} color={chipColor} className={currentConfig?.className} />
  );
};

export default StatusChip;
